import * as XLSX from "xlsx";

// Kökteki PersonelYüklemeŞablonu.xlsx / BakiyeYüklemeŞablonu.xlsx ile birebir
// aynı sayfa adları ve sütun başlıkları. Kullanıcı boş şablonu buradan indirir,
// doldurup geri yükler.
//
// DİKKAT: Gerçek şablonlarda başlıklarda ve hücrelerde sondaki boşluklar var
// ("Sicil No ", "01.00.01231 "). Bu yüzden hem başlık hem değer eşlemesi
// trim'lenerek yapılıyor — kullanıcı elindeki dosyayı olduğu gibi yükleyebilsin.

export const PERSONAL_TEMPLATE = {
  fileName: "PersonelYuklemeSablonu.xlsx",
  sheetName: "PersonelEklemeTablosu",
  headers: ["Sicil No", "Kart No", "Adı", "Soyadı", "DepartmanId"],
  example: ["01.00.01231", "0010139254", "ÖRNEK_AD", "ÖRNEK_SOYAD", 5],
};

export const BALANCE_TEMPLATE = {
  fileName: "BakiyeYuklemeSablonu.xlsx",
  sheetName: "Güncel liste",
  headers: ["Sicil No", "Adı", "Soyadı", "Bakiye(Kuruş)"],
  example: ["01.00.01231", "ÖRNEK_AD", "ÖRNEK_SOYAD", 480],
};

/** Boş şablonu (başlık + 1 örnek satır) indirir. */
export function downloadTemplate(template) {
  const ws = XLSX.utils.aoa_to_sheet([template.headers, template.example]);
  ws["!cols"] = template.headers.map((h) => ({ wch: Math.max(14, h.length + 4) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, template.sheetName);
  XLSX.writeFile(wb, template.fileName);
}

const norm = (v) => String(v ?? "").trim();

/**
 * Yüklenen dosyayı satır nesnelerine çevirir.
 * Başlıklar trim'lenir; ilk sayfa okunur (şablon sayfa adı değişmiş olabilir).
 * @returns {Promise<Array<Object>>} başlık -> değer (ikisi de trim'li)
 */
export function readSheet(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Dosya okunamadı"));
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const matrix = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
        if (matrix.length < 2) {
          reject(new Error("Dosyada veri satırı yok"));
          return;
        }
        const headers = matrix[0].map(norm);
        const rows = matrix
          .slice(1)
          .filter((r) => r.some((c) => norm(c) !== ""))
          .map((r) =>
            headers.reduce((acc, h, i) => {
              if (h) acc[h] = typeof r[i] === "number" ? r[i] : norm(r[i]);
              return acc;
            }, {})
          );
        resolve(rows);
      } catch (err) {
        reject(new Error("Geçersiz Excel dosyası"));
      }
    };
    reader.readAsArrayBuffer(file);
  });
}

/** Beklenen başlıklar dosyada var mı? Yoksa hangileri eksik? */
export function missingHeaders(rows, template) {
  if (!rows.length) return template.headers;
  const present = Object.keys(rows[0]);
  return template.headers.filter((h) => !present.includes(h));
}
